<app-filter-group  *ngFor="let filterGroupData of filtersData"
    [filterGroupData]="filterGroupData" (selectedOption)="addOptionToOptionsFilter($event)"
    [availableOptionsF]="filteredOptionValuesArray">
</app-filter-group>

